const PRESERVED_WORKSPACE_SECTIONS = new Set([
  'dashboard',
  'profile',
  'billing',
  'stores/config',
  'products',
  'products/add',
  'categories',
  'product-visibility',
  'competitors',
  'competitors/add',
  'notifications',
  'king-of-marketplaces',
])

export function buildWorkspaceSwitchPath(currentPathname: string, targetOrgId: string): string {
  const match = currentPathname.match(/^\/o\/[^/]+\/?(.*)$/)
  const sectionPath = match?.[1]?.replace(/^\/+|\/+$/g, '') || 'dashboard'

  if (PRESERVED_WORKSPACE_SECTIONS.has(sectionPath)) {
    return `/o/${targetOrgId}/${sectionPath}`
  }

  return `/o/${targetOrgId}/dashboard`
}
